export class AppEvents {
    public static readonly SettingsClose = "SettingsClose";
    public static readonly SettingsVisibilityToggled = "SettingsVisibilityToggled";
    public static readonly SearchRequest = "SearchRequest";
    public static readonly NewSearchComponents = "NewSearchComponents";
    public static readonly ErrorMessage = "ErrorMessage";
    public static readonly SearchServerRequestFailed = "SearchServerRequestFailed";
    public static readonly SearchServerRequestComplete = "SearchServerRequestComplete";
    public static readonly SearchCompleted = "SearchCompleted";
    public static readonly CancelSuggestions = "CancelSuggestions";
    public static readonly SignOut = "SignOut";
    public static readonly SigninSuccessful = "SigninSuccessful";
    public static readonly DocumentHolderClosed = "DocumentHolderClosed";
    public static readonly DesktopMode = "DesktopMode";
    public static readonly JurisdictionsSaved = "JurisdictionsSaved";
    public static readonly WindowResized = "WindowResized";
    public static readonly TotalSearchResults = "TotalSearchResults";
    public static readonly ProcessRequestSuccess = "ProcessRequestSuccess";
    public static readonly CitationHighlightToggle = "CitationHighlightToggle";
    public static readonly UpdateJurisdictionFilterMessage = "UpdateJurisdictionFilterMessage";
    public static readonly HideDialogs = "HideDialogs";
    public static readonly HistoryBack = "HistoryBack";
    public static readonly CloseAdvanced = "CloseAdvanced";
    public static readonly RefreshResultsPagerPopup = "RefreshResultsPagerPopup";
    public static readonly ClearCategoryFilter = "ClearCategoryFilter";
    public static readonly DesktopDocumentRemoved = "DesktopDocumentRemoved";
    public static readonly DesktopDocumentAdded = "DesktopDocumentAdded";
    public static readonly DocumentReadyForPrecedentMap = "DocumentReadyForPrecedentMap";
    public static readonly LoadDocumentCategories = "LoadDocumentCategories";
    public static readonly InformationMessage = "InformationMessage";
    public static readonly QuickInformationMessage = "QuickInformationMessage";
    public static readonly CategoryDocumentSectionChanged = "CategoryDocumentSectionChanged";
    public static readonly ClearSearch = "ClearSearch";
    public static readonly ProcessingHide = "ProcessingHide";
    public static readonly HideSuggestions = "HideSuggestions";
    public static readonly Desktop = "Desktop";
    public static readonly UserHistory = "UserHistory";
    public static readonly DocumentLoaded = "DocumentLoaded";
    public static readonly PageRefresh = "PageRefresh";
    public static readonly HideAdvancedSearch = "HideAdvancedSearch";
    public static readonly DocumentRequested = "DocumentRequested";
    public static readonly Package = "Package";
    public static readonly PrecedentMapDisplayTypesChanged = "PrecedentMapDisplayTypesChanged";
    public static readonly PrecedentMapLoaded = "PrecedentMapLoaded";
    public static readonly EditorialUpdateResponse = "EditorialUpdateResponse";
    public static readonly CiteLineEngaged = "CiteLineEngaged";
    public static readonly CiteLineClosed = "CiteLineClosed";
    public static readonly ViewLegislationRevision = "ViewLegislationRevision";
    public static readonly ClearCIC = "ClearCIC";
    public static readonly BrowseSearchRequest = "BrowseSearchRequest";
    public static readonly AdvancedSearchFormsLoaded = "AdvancedSearchFormsLoaded";
    public static readonly ResetSearch = "ResetSearch";
    public static readonly ViewStatuteOutline = "ViewStatuteOutline";
    public static readonly ClearSearchBox = "ClearSearchBox";
    public static readonly ClearFilters = "ClearFilters";
    public static readonly Announcement = "Announcement";
    public static readonly PrintFullText = "PrintFullText";

    // All App Insight events must start with "AI:" so that the event handler that intercepts these will 
    // perform the telemtry logging to Azure
    public static readonly AppInsightsDocumentDownload = "AI:Document:Download";
    public static readonly AppInsightsSearchDownload = "AI:Search:Download";
    public static readonly AppInsightsBrowsePanelLinkClick = "AI:Browse:PanelLinkClick";
    public static readonly AppInsightsBrowseFindCases = "AI:Browse:FindCases";
    public static readonly AppInsightsSearchStandard = "AI:Search:Standard:DoSearch";
    public static readonly AppInsightsSearchAdvanced = "AI:Search:Advanced:DoSearch";
    public static readonly AppInsightsSearchClear = "AI:Search:Clear";
    public static readonly AppInsightsSearchClearProductFilter = "AI:Search:Advanced:ClearProductFilter";
    public static readonly AppInsightsResultsFilter = "AI:Results:Filter";
    public static readonly AppInsightsResultsFilterDropDownActivated = "AI:Results:Filter:DropDownActivated";
    public static readonly AppInsightsSettingsVisibilityToggled = "AI:Settings:VisibilityToggled";
    public static readonly AppInsightsSourceLinksSeleced = "AI:Settings:SourceLinks:Selected";
    public static readonly AppInsightsJurisdictionsSaved = "AI:Settings:Jurisdictions:Saved";
    public static readonly AppInsightsOrganisationSaved = "AI:Settings:OrganisationDetails:Saved";
    public static readonly AppInsightsDocumentPDFView = "AI:Document:PDF:View";
    public static readonly AppInsightsDocumentReadMode = "AI:Document:Readmode";
    public static readonly AppInsightsDocumentCitationsInContextClick = "AI:Document:CIC:Click";
    public static readonly AppInsightsDocumentTabClick = "AI:Document:Tab:Click";
    public static readonly AppInsightsDocumentHighlightTerm = "AI:Document:HighlightTerm";
    public static readonly AppInsightsDocumentStageSelected = "AI:Document:StageSelected";
    public static readonly AppInsightsDocumentKeyParaGotoLink = "AI:Document:KeyPara:GotoLink";
    public static readonly AppInsightsDocumentMetaGotoLink = "AI:Document:Meta:GotoLink";
    public static readonly AppInsightsDocumentSourcesGotoLink = "AI:Document:Sources:GotoLink";
    public static readonly AppInsightsDocumentPrecedentMapOpen = "AI:Document:PrecedentMap:Open";
    public static readonly AppInsightsDocumentPowerParaClicked = "AI:Document:PowerPara:Clicked";
    public static readonly AppInsightsDocumentHighlightQuotedClicked = "AI:Document:HighlightQuotedPara:Clicked";
    public static readonly AppInsightsDesktopDocumentView = "AI:Desktop:DocumentViewMode";
    public static readonly AppInsightsDesktopAdminButton = "AI:Desktop:AdminButton";
    public static readonly AppInsightsDesktopHelpButton = "AI:Desktop:HelpButton";
    public static readonly AppInsightsDesktopBugButton = "AI:Desktop:BugButton";
    public static readonly AppInsightsDashboardRunSearch = "AI:Dashboard:RunSearch";       // obsolete but is here for log reference
    public static readonly AppInsightsDashboardGotoDocument = "AI:Dashboard:GotoDocument"; // obsolete but is here for log reference
    public static readonly AppInsightsDashboardGetCertified = "AI:Dashboard:GetCertified"; // obsolete but is here for log reference
    public static readonly AppInsightsDashboardLearnMore = "AI:Dashboard:LearnMore";       // obsolete but is here for log reference
    public static readonly AppInsightsHistory = "AI:History:Action";
    public static readonly AppInsightsAlertChange = "AI:Alert:Change";
    public static readonly AppInsightsAdvancedSearchFieldHelpFeedback = "AI:AdvancedSearch:FieldHelp:Feedback";
    public static readonly AppInsightsAdvancedSearchFieldHelp = "AI:AdvancedSearch:FieldHelp:Clicked";

    // My Justis
    public static readonly AppInsightsMyJustisRunLastSearchResult = "AI:MyJustis:RunLastSearchResult";
    public static readonly AppInsightsMyJustisGetCertified = "AI:MyJustis:GetCertified";
    public static readonly AppInsightsMyJustisTrainingEmailClicked = "AI:MyJustis:TrainingEmail:Clicked";
    public static readonly AppInsightsMyJustisCoverageClicked = "AI:MyJustis:Coverage:Clicked";
    public static readonly AppInsightsMyJustisGotoDocument = "AI:MyJustis:GotoDocument";

    // Mobile Only
    public static MobileDocumentListToggled = "MobileDocumentListToggled";
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/app-events.ts